'use strict';

var _ = require('lodash');
var SystemConfigurationToolbarController = function SystemConfigurationToolbarController($scope, $rootScope, featureToggleService, systemConfigurationToolbarBookmarksService, searchCriteriaConstantsService, userSecureService, SystemConstants) {
  $scope.screen = searchCriteriaConstantsService.SYSTEM_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET;
  $scope.getFirstValidBookmark = function (bookmarks) {
    var bookmark = _.find(bookmarks, function (item) {
      return userSecureService.hasAuthorization(item.value);
    });
    return bookmark && bookmark.value;
  };
  $scope.setupBookmarks = function () {
    $scope.bookmarks = systemConfigurationToolbarBookmarksService.getBookmarks();
    $scope.selectedBookmark = $scope.getFirstValidBookmark($scope.bookmarks);
  };
  $scope.setupBookmarks();
  $scope.$watch('selectedBookmark', function () {
    $rootScope.$broadcast('system-configuration:modeChanged', $scope.selectedBookmark);
  });
  $scope.$on('market-class-fare:view-changed', function (event, screenKey) {
    $scope.screen = searchCriteriaConstantsService[screenKey];
  });
  $scope.$on('user-ref-data:view-changed', function (event, screenKey) {
    $scope.screen = searchCriteriaConstantsService[screenKey];
  });
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.isSearchButtonVisible = function () {
    return SystemConstants.SCREEN_VALUE.SYSTEM_CONFIG.MARKET_CLASS_FARE === $scope.selectedBookmark;
  };
  $scope.isWebFareVisible = function () {
    return featureToggleService.isEnabled('COMPFARE_AVAILABILITY') && featureToggleService.isEnabled('USE_WEB_FARE');
  };
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    if (toParams && toParams.transitionData) {
      var action = toParams.transitionData['system-configuration:force-tab'];
      if (action) {
        $scope.selectedBookmark = action.tabId || $scope.screen;
      } else {
        $scope.selectedBookmark = $scope.screen;
      }
    }
    $scope.$broadcast('configuration-host-share:navigation-from-global');
  });
};
SystemConfigurationToolbarController.$inject = ['$scope', '$rootScope', 'FeatureToggleService', 'SystemConfigurationToolbarBookmarksService', 'SearchCriteriaConstantsService', 'UserSecureService', 'SystemConstants'];
module.exports = SystemConfigurationToolbarController;